export const OpKinds = Object.freeze({
    SET_ALT_TEXT: "set-alt-text",
    SET_TEXT: "set-text",
    SET_ROLE: "set-role",
    SET_ACTUAL_TEXT: "set-actual-text",
    SET_LANG: "set-lang",
    SET_ID: "set-id",
    SET_TITLE: "set-title",
    SET_SLIDE_TITLE: "set-slide-title",
    MARK_DECORATIVE: "mark-decorative",
    REORDER_READING: "reorder-reading",
    ADD_CHILD: "add-child",
    REMOVE_CHILD: "remove-child",
    FUSE_SIBLINGS: "fuse-siblings",
    MOVE_SUBTREE: "move-subtree",
    SET_BBOX: "set-bbox",
    REASSOCIATE_MCIDS: "reassociate-mcids",
    CLEAR_ALL_TAGS: "clear-all-tags",
    EDIT_CATALOG: "edit-catalog",
    SET_METADATA_FIELD: "set-metadata-field",
    SET_ROLE_MAPPING: "set-role-mapping",
    SET_STRUCT_ATTRIBUTE: "set-struct-attribute",
    WRAP_RANGE_AS_SECT: "wrap-range-as-sect",
    SET_COLOR: "set-color",
    SET_LINK_TEXT: "set-link-text",
    SET_HEADING_LEVEL: "set-heading-level",
    SET_RUN_LANG: "set-run-lang",
    SET_TABLE_HEADER_ROW: "set-table-header-row",
    SET_SHEET_NAME: "set-sheet-name",
    SET_SECTION_NAME: "set-section-name",
    BATCH: "BATCH",
});
